import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { QRCodesPage } from '../pages';
import { CreateEditQRCode } from '../pages';

export const routes = (
  <>
    <Route
      path="/qr-codes"
      element={
        <PrivateRoute>
          <QRCodesPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/qr-codes/create"
      element={
        <PrivateRoute>
          <CreateEditQRCode />
        </PrivateRoute>
      }
    />
    <Route
      path="/qr-codes/edit"
      element={
        <PrivateRoute>
          <CreateEditQRCode />
        </PrivateRoute>
      }
    />
  </>
);


